import PlatformContentContainer from './PlatformContentContainer';

export default PlatformContentContainer;
